<template>
    <cp-select
        :config="routeBanks"
        item-value="id"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
        :customItem="true"
        :returnObject="returnObject"
    >
        <template v-slot:selection="{ item }">
            <strong>{{ item.code }}</strong> - {{ item.name }}
        </template>

        <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-content>
                    <v-list-item-title>
                        <strong>{{ item.code }}</strong> - {{ item.name }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        routeBanks: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.core.banks'} },
        },
        returnObject: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione um Banco',
                name: name || "select-bank"
            }, ...attrs };
        },
    },
}
</script>